import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import type { RetryDistributionBucket } from '../../types';
import { AXIS_TICK, CHART_COLORS, TOOLTIP_STYLE } from './theme';

/** How many deliveries finally succeeded on attempt 1, 2, 3, … */
export function RetryDistributionChart({ buckets }: { buckets: RetryDistributionBucket[] }) {
  const data = buckets.map((bucket) => ({
    label: `Attempt ${bucket.attemptNumber}`,
    Succeeded: bucket.succeeded,
  }));

  if (data.length === 0) {
    return <p className="chart__empty">No successful deliveries to distribute yet.</p>;
  }

  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={data} margin={{ top: 8, right: 8, bottom: 4, left: 0 }}>
        <CartesianGrid stroke={CHART_COLORS.grid} vertical={false} />
        <XAxis dataKey="label" tick={AXIS_TICK} tickLine={false} axisLine={{ stroke: CHART_COLORS.grid }} />
        <YAxis
          tick={AXIS_TICK}
          tickLine={false}
          axisLine={{ stroke: CHART_COLORS.grid }}
          allowDecimals={false}
          width={44}
        />
        <Tooltip contentStyle={TOOLTIP_STYLE} cursor={{ fill: 'rgba(91,155,255,0.08)' }} />
        <Bar dataKey="Succeeded" fill={CHART_COLORS.accent} radius={[4, 4, 0, 0]} maxBarSize={64} />
      </BarChart>
    </ResponsiveContainer>
  );
}
